// Helper function to safely convert to lowercase string
const safeToLowerCase = (value: any): string => {
  if (value === null || value === undefined) return "";
  return String(value).toLowerCase();
};

// Helper function to safely replace spaces and special characters
const safeFormatForTestId = (value: any): string => {
  if (value === null || value === undefined) return "";
  return String(value)
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
};

export const generateTestId = {
  // Table-related test IDs
  table: (dataType: any, element: any, index?: number | string) =>
    `table-${safeToLowerCase(dataType)}-${safeToLowerCase(element)}${index !== undefined ? `-${index}` : ""}`,

  // Form-related test IDs
  form: (type: any, name: any, dataType?: any) =>
    `form-${safeToLowerCase(type)}-${dataType ? `${safeToLowerCase(dataType)}-` : ""}${safeFormatForTestId(name)}`,

  // Action/Button test IDs
  action: (verb: any, noun: any, state?: any) =>
    `action-${safeToLowerCase(verb)}-${safeToLowerCase(noun)}${state ? `-${safeToLowerCase(state)}` : ""}`,

  // Navigation test IDs
  nav: (type: any, target: any) =>
    `nav-${safeToLowerCase(type)}-${safeFormatForTestId(target)}`,

  // Modal/Dialog test IDs
  modal: (purpose: any, action?: any) =>
    `modal-${safeFormatForTestId(purpose)}${action ? `-${safeToLowerCase(action)}` : ""}`,

  // Input field test IDs
  input: (dataType: any, fieldName: any) =>
    `input-${safeToLowerCase(dataType)}-${safeFormatForTestId(fieldName)}`,

  // Button test IDs
  button: (action: any, context?: any, state?: any) =>
    `button-${safeToLowerCase(action)}${context ? `-${safeToLowerCase(context)}` : ""}${state ? `-${safeToLowerCase(state)}` : ""}`,

  // Section/Container test IDs
  section: (type: any, context?: any) =>
    `section-${safeToLowerCase(type)}${context ? `-${safeFormatForTestId(context)}` : ""}`,

  // Widget/Dashboard test IDs
  widget: (type: any, metric?: any) =>
    `widget-${safeToLowerCase(type)}${metric ? `-${safeFormatForTestId(metric)}` : ""}`,

  // Generic item test IDs for lists
  item: (dataType: any, id: string | number, element?: any) =>
    `item-${safeToLowerCase(dataType)}-${id}${element ? `-${safeToLowerCase(element)}` : ""}`,

  // CRUD-specific test IDs
  crud: (operation: any, dataType: any, context?: any) =>
    `crud-${safeToLowerCase(operation)}-${safeToLowerCase(dataType)}${context ? `-${safeToLowerCase(context)}` : ""}`,

  // Loading/Status test IDs
  status: (type: any, state: any) =>
    `status-${safeToLowerCase(type)}-${safeToLowerCase(state)}`,

  // Icon test IDs
  icon: (purpose: any, state?: any) =>
    `icon-${safeToLowerCase(purpose)}${state ? `-${safeToLowerCase(state)}` : ""}`
};

export const normaliseForTestId = (str: string): string =>
  str
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");

export const combineTestId = (
  ...parts: Array<string | number | undefined>
): string =>
  parts
    .filter(Boolean)
    .map((part) => normaliseForTestId(String(part)))
    .join("-");
